import {
	ActionPayrollContainer,
	BulkAddFundsContainer,
	BulkDeductFundsContainer,
	EmployeePayDetailsContainer,
	PayrollSummaryContainer,
	ReviewPayrollContainer,
	ViewEmployeesContainer,
	ViewPayrollContainer,
	UploadSalesSheetContainer,
	CreatePayrollContainer,
} from '../../containers';
import {
	AppPage,
	MimaText,
	PageLoader,
	ReceiptCheckBox as RCB,
	Searchbar,
	MimaFilter,
} from '../../components';

import styles from '../../assets/styles/Employees/Employees.module.scss';
import { downloadFormatDate, downloadXlsx2 } from '../../utils/download';
import React, { useLayoutEffect, useState } from 'react';
import { amountFormatter } from '../../utils/utils';
import { useMediaQuery } from 'react-responsive';
import { AnimatePresence } from 'framer-motion';
import constant from '../../utils/constant';
import { payrollStore } from '../../stores';
import { Formik } from 'formik';
import moment from 'moment';
import { toJS } from 'mobx';

const Payroll = ({
	viewEmployees,
	loading,
	saleSheet,
	createPayroll,
	generatePayroll,
	viewPayroll,
	action,
	addIdFromArray,
	statuses,
	removeIdFromArray,
	viewPayrollSummary,
	actionPayroll,
	closeModal,
	tags,
	requester,
	onDeptClick,
	onStatusClick,
	onTagClick,
	validationSchema,
	onSubmit,
	status,
	dept,
	tag,
	employeeNav,
	employeePayBreakdown,
	goToEmployeePayBreakdown,
	bulkAddFunds,
	goToBulkDeductFunds,
	goToBulkAddFunds,
	refresh,
	bulkDeductFunds,
	review,
	viewMore,
	departments,
	goToViewMore,
	setViewMore,
}) => {
	const [payroll, setPayroll] = useState({});
	const isBelow800 = useMediaQuery({
		query: '(max-width: 800px)',
	});
	const isBelow700 = useMediaQuery({
		query: '(max-width: 700px)',
	});

	const [filteredPayroll, setFilteredPayroll] = useState([]);
	const [letterX, setLetterX] = useState(null);
	const [letterY, setLetterY] = useState(null);

	const { payrolls } = payrollStore || {};

	let deviceSize = window.innerWidth;

	useLayoutEffect(() => {
		if (deviceSize > 600 && deviceSize <= 700) {
			setLetterX(4);
			setLetterY(3);
		} else if (deviceSize > 500 && deviceSize <= 600) {
			setLetterX(3);
			setLetterY(2);
		} else if (deviceSize > 400 && deviceSize <= 500) {
			setLetterX(2);
			setLetterY(1);
		} else if (deviceSize <= 400) {
			setLetterX(1);
			setLetterY(0);
		} else {
			setLetterX(5);
			setLetterY(4);
		}
	}, [deviceSize]);

	// JSON to convert to Excel
	const printData = filteredPayroll
		.filter(pay => pay.status !== constant.STATUS.IGNORE)
		.map(payroll => ({
			Name: `${payroll.user?.firstname} ${payroll.user?.middlename || ''} ${
				payroll.user?.lastname
			}`,
			'Initial Gross Salary': payroll?.initialGross?.toFixed(2) || 0,
			'Gross Salary': payroll?.grossPay?.toFixed(2) || 0,
			'Net Salary': payroll?.netPay?.toFixed(2) || 0,
			'PAYE Tax': payroll?.tax !== 0 ? `-${payroll?.tax?.toFixed(2)}` : 0,
			WHT: payroll?.wht !== 0 ? `-${payroll?.wht?.toFixed(2)}` : 0,
			Pension: payroll?.pension !== 0 ? `-${payroll?.pension?.toFixed(2)}` : 0,
			NHF: payroll?.nhf !== 0 ? `-${payroll.nhf}` : 0,
			'Extra Deduction': `-${payroll.payDeductions.reduce(
				(acc, fund) => acc + fund.amount,
				0
			)}`,
			'Extra Addition': payroll.payAdditions.reduce(
				(acc, fund) => acc + fund.amount,
				0
			),
			tag: payroll.tag,
			Status: payroll.status,
			'Pay Day': moment(payroll.payDay).format('DD-MM-YYYY hh:mm'),
			'Approved Date': payroll.approver?.date
				? moment(payroll.approver?.date).format('DD-MM-YYYY hh:mm')
				: '',
			'Paid Date': payroll.actualPaidDate
				? moment(payroll.actualPaidDate).format('DD-MM-YYYY hh:mm')
				: '',
		}));

	return (
		<AppPage
			onClick={() => {
				if (viewMore) {
					setViewMore(false);
				}
			}}
			refresh={refresh}
			pageTitle="Payroll">
			<div className={styles.main}>
				<Formik
					initialValues={{
						ids: [],
						all: false,
					}}
					validationSchema={validationSchema}
					onSubmit={onSubmit}>
					{({ handleSubmit, values, setFieldValue }) => (
						<>
							<div className={styles.main_nav_group}>
								<div className={styles.main_nav}>
									{employeeNav.slice(0, letterX).map((navItem, index) => (
										<div
											key={index}
											onClick={() => {
												if (navItem.title === 'Ignore') {
													setFieldValue('status', constant.STATUS.IGNORE);
													handleSubmit();
												} else if (navItem.title === 'Unignore') {
													setFieldValue('status', constant.STATUS.PENDING);
													handleSubmit();
												} else if (navItem.title === 'Deduct Funds in Bulk') {
													goToBulkDeductFunds(values.ids);
												} else if (navItem.title === 'Add Funds in Bulk') {
													goToBulkAddFunds(values.ids);
												} else if (navItem.title === 'Download Report') {
													downloadXlsx2(
														printData,
														`payroll-${tag}-${downloadFormatDate(new Date())}`
													);
												} else {
													navItem.clickAction();
												}
											}}
											className={styles.main_nav_item}>
											{navItem.title}
										</div>
									))}
									<div className={styles.main_nav_item} onClick={goToViewMore}>
										View More Actions
									</div>
								</div>
								{viewMore && (
									<div className={styles.main_nav_more}>
										{employeeNav
											.filter((e, i) => i > letterY)
											.map((navItem, index) => (
												<div
													key={index}
													onClick={() => {
														if (navItem.title === 'Deduct Funds in Bulk') {
															goToBulkDeductFunds(values.ids);
														} else if (navItem.title === 'Ignore') {
															setFieldValue('status', constant.STATUS.IGNORE);
															handleSubmit();
														} else if (navItem.title === 'Unignore') {
															setFieldValue('status', constant.STATUS.PENDING);
															handleSubmit();
														} else if (navItem.title === 'Add Funds in Bulk') {
															goToBulkAddFunds(values.ids);
														} else if (navItem.title === 'Download Report') {
															downloadXlsx2(
																printData,
																`payroll-${tag}-${downloadFormatDate(
																	new Date()
																)}`
															);
														} else {
															navItem.clickAction();
														}
													}}
													className={styles.main_nav_item}>
													{navItem.title}
												</div>
											))}
									</div>
								)}
							</div>
							<MimaFilter noButton>
								<div className={styles.filter_title}>STATUS</div>
								<div className={styles.filter_group}>
									{statuses.map((stat, i) => (
										<div
											key={stat}
											onClick={() => onStatusClick(stat)}
											className={
												stat === status
													? styles.filter_selectedItem
													: styles.filter_item
											}>
											{stat}
										</div>
									))}
								</div>
								<div className={styles.filter_title}> Employee Tags </div>
								<div className={styles.filter_group}>
									{tags.map((tagValue, i) => (
										<div
											key={tagValue.key}
											onClick={() => onTagClick(tagValue.value)}
											className={
												tagValue.value === tag
													? styles.filter_selectedItem
													: styles.filter_item
											}>
											{tagValue.value}
										</div>
									))}
								</div>
								<div className={styles.filter_title}> Departments </div>
								<div className={styles.filter_group}>
									{departments.map((deptValue, i) => (
										<div
											key={i}
											onClick={() => onDeptClick(deptValue)}
											className={
												deptValue._id === dept._id
													? styles.filter_selectedItem
													: styles.filter_item
											}>
											{deptValue.name}
										</div>
									))}
								</div>
							</MimaFilter>

							<div className="searchInMiddle">
								<Searchbar
									placeholder="Search Payroll"
									variant="wide"
									input={payrolls && payrolls?.length > 0 ? payrolls : []}
									loading={false}
									output={setFilteredPayroll}
									width={isBelow700 ? 38 : 60}
									handleFilter={(item, searchQuery) => {
										return (
											item?.employee?.jobTitle
												?.toLowerCase()
												?.includes(searchQuery) ||
											item?.user?.firstname
												?.toLowerCase()
												?.includes(searchQuery) ||
											item?.user?.lastname
												?.toLowerCase()
												?.includes(searchQuery) ||
											item?.netPay.toString()?.includes(searchQuery)
										);
									}}
								/>
							</div>

							<>
								{loading ? (
									<PageLoader
										title="while we fetch your records"
										loading={loading}
									/>
								) : (
									<>
										<div className={styles.simpleTable}>
											<MimaText align="center" color="var(--color-primary)">
												{payrolls && payrolls?.length > 0 && payrolls[0]?.payDay
													? `Expected Pay Day is ${moment(
															toJS(payrolls)[0]?.payDay
														).format('Do MMMM, YYYY')}`
													: ''}
											</MimaText>
											<MimaText align="right" color="var(--color-primary)">
												Tag: {`${tag}`}
											</MimaText>
											<MimaText align="right" color="var(--color-primary)">
												Status: {`${status || 'ALL'}`}
											</MimaText>
											<MimaText align="right" color="var(--color-primary)">
												Department: {`${dept.name || 'ALL'}`}
											</MimaText>

											{/* <MimaButton
												title="Download Report"
												width={20}
												onClick={() => {
													downloadXlsx2(
														printData,
														`payroll-${tag}-${downloadFormatDate(new Date())}`
													);
												}}
												variant="filter"
												buttonColor="var(--color-primary)"
												mt={2}
											/> */}

											<table id="payroll-table">
												<thead>
													<tr>
														<th>
															<RCB
																title=""
																onChange={() => {
																	if (!values.all) {
																		const payrollsItem = toJS(payrolls).filter(
																			payroll =>
																				payroll.status ===
																					constant.STATUS.PENDING ||
																				payroll.status ===
																					constant.STATUS.REQUEST_CHANGE ||
																				payroll.status ===
																					constant.STATUS.IGNORE
																		);
																		const ids = payrollsItem.map(
																			payroll => payroll._id
																		);
																		setFieldValue('ids', ids);
																		setFieldValue('all', !values.all);
																	} else {
																		setFieldValue('ids', []);
																		setFieldValue('all', !values.all);
																	}
																}}
																id={0}
																name={0}
																checked={values.all}
															/>
														</th>
														<th> Name </th>
														<th> Job role </th>
														{/* {!isBelow800 && <th> Employment Type</th>} */}
														{!isBelow800 && <th> Initial Gross Salary </th>}
														<th> Net Salary </th>
														<th> Status </th>
														{!isBelow800 && <th> Bank Account Name</th>}
														<th> Action </th>
													</tr>
												</thead>
												<tbody>
													{filteredPayroll.map(payroll => (
														<tr key={payroll._id}>
															<td>
																{(payroll.status === constant.STATUS.PENDING ||
																	payroll.status ===
																		constant.STATUS.REQUEST_CHANGE ||
																	payroll.status ===
																		constant.STATUS.IGNORE) && (
																	<RCB
																		title=""
																		onChange={() => {
																			const found = values.ids.find(
																				id => id === payroll._id
																			);
																			if (found) {
																				setFieldValue('all', false);
																			}
																			const ids = !found
																				? addIdFromArray(
																						values.ids,
																						payroll._id
																					)
																				: removeIdFromArray(
																						values.ids,
																						payroll._id
																					);
																			setFieldValue('ids', ids);
																		}}
																		id={payroll?._id}
																		name={payroll?._id}
																		checked={values.ids.find(
																			id => id === payroll._id
																		)}
																	/>
																)}
															</td>
															<td>
																{`${payroll?.user?.firstname} ${payroll.user?.lastname}`}
															</td>
															<td> {payroll?.employee?.jobTitle} </td>
															{/* {!isBelow800 && (
																<td> {payroll?.employee?.employmentType} </td>
															)} */}
															{!isBelow800 && (
																<td>
																	{amountFormatter().format(
																		payroll?.initialGross
																	)}
																</td>
															)}
															{/* {!isBelow800 && ( */}
															<td>
																{amountFormatter().format(payroll?.netPay)}
															</td>
															{/* )} */}

															{/* {!isBelow800 && ( */}
															<td
																className={
																	payroll?.status === constant.STATUS.PENDING ||
																	payroll?.status === constant.STATUS.IN_REVIEW
																		? styles.pending
																		: payroll?.status ===
																					constant.STATUS.PAID ||
																			  payroll?.status ===
																					constant.STATUS.APPROVED
																			? styles.paid
																			: payroll?.status ===
																						constant.STATUS.FAILED ||
																				  payroll?.status ===
																						constant.STATUS.VOID ||
																				  payroll?.status ===
																						constant.STATUS.IGNORE
																				? styles.failed
																				: payroll?.status ===
																					  constant.STATUS.REQUEST_CHANGE
																					? styles.change
																					: styles.others
																}>
																{payroll?.status}
															</td>
															{/* )} */}
															{!isBelow800 && (
																<td>
																	{payroll?.withdrawalBankAccount?.accountName}
																</td>
															)}
															<td
																className={styles.action__text}
																onClick={() => {
																	setPayroll(payroll);
																	goToEmployeePayBreakdown();
																}}>
																View More
															</td>
														</tr>
													))}
												</tbody>
											</table>
										</div>
									</>
								)}
							</>
						</>
					)}
				</Formik>
			</div>
			{(viewEmployees ||
				generatePayroll ||
				viewPayroll ||
				createPayroll ||
				actionPayroll ||
				viewPayrollSummary ||
				employeePayBreakdown ||
				bulkAddFunds ||
				bulkDeductFunds ||
				saleSheet ||
				review) && (
				<div className="modal">
					<AnimatePresence>
						{viewEmployees && (
							<ViewEmployeesContainer closeModal={closeModal} />
						)}

						{actionPayroll && (
							<ActionPayrollContainer closeModal={closeModal} />
						)}

						{viewPayroll && <ViewPayrollContainer closeModal={closeModal} />}

						{createPayroll && (
							<CreatePayrollContainer closeModal={closeModal} />
						)}

						{viewPayrollSummary && (
							<PayrollSummaryContainer
								closeModal={closeModal}
								employeePayBreakdown={employeePayBreakdown}
								goToEmployeePayBreakdown={goToEmployeePayBreakdown}
							/>
						)}

						{employeePayBreakdown && (
							<EmployeePayDetailsContainer
								payroll={payroll}
								closeModal={closeModal}
							/>
						)}

						{bulkAddFunds && <BulkAddFundsContainer closeModal={closeModal} />}
						{bulkDeductFunds && (
							<BulkDeductFundsContainer closeModal={closeModal} />
						)}
						{review && (
							<ReviewPayrollContainer
								closeModal={closeModal}
								requester={requester}
								action={action}
							/>
						)}
						{saleSheet && <UploadSalesSheetContainer closeModal={closeModal} />}
					</AnimatePresence>
				</div>
			)}
		</AppPage>
	);
};

export default Payroll;
